import { render } from "./MenuApt.vue?vue&type=template&id=c9393530&scoped=true"
import script from "./MenuApt.vue?vue&type=script&lang=js"
export * from "./MenuApt.vue?vue&type=script&lang=js"

import "./MenuApt.vue?vue&type=style&index=0&id=c9393530&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c9393530"

export default script